/**
 * The E2E run id, injected by the test harness via an init script. Undefined in
 * real sessions. Forwarded on the socket payload so GMS can tag the received
 * denominator, keeping synthetic traffic identified consistently with the
 * platform-emitted numerator.
 */
export function e2eRunId(): string | undefined {
  return (globalThis as { __E2E_RUN_ID__?: string }).__E2E_RUN_ID__;
}
